export enum OfferCoverageDestinyCode {
    FILTER = 'FILTER',
    COMPARE = 'COMPARE',
    OFFER_MODIFICATION = 'OFFER_MODIFICATION',
    DETAIL_BOX = 'DETAIL_BOX',
    PRIMARY_BOX = 'PRIMARY_BOX',
    DETAIL_FILTER = 'DETAIL_FILTER',
    PRIMARY_FILTER = 'PRIMARY_FILTER',
}
